import axios from './index';

// v1: deprecated. replaced by onboardClientRequest
export const _signUpUser = (obj) => {
  return axios.post('public/v1/app/s/create', obj);
};

// v1: deprecated.
export const _signInUser = (obj) => {
  return axios.post('public/v1/app/authenticate', obj);
};

export const signInUser = (obj) => axios.post('v1/admins/login/admin', obj);

export const onboardClientRequest = (obj) =>
  axios.post('v1/admins/issuers/create/issuer', obj);

export const updateClientRequest = (id, obj) =>
  axios.put(`v1/admins/issuers/update/issuer/${id}`, obj);
